import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..'; // 在 store/index.ts 中声明的类型

// 借助 createSlice 创建 reducer、action
const ExportDataSlice = createSlice({
    name: 'exportData',
    initialState: {
        value: [],
    },
    reducers: {
        setExportData: (state, action: PayloadAction<[]>) => {
            state.value = action.payload;
        },
    },
});

// Action Creator 用于执行返回描述如何更新 state 的 Action
export const { setExportData } = ExportDataSlice.actions;

// Selector，作为 useSelector 读取数据的函数参数
export const exportDataSelector = (state: RootState) => state.exportData.value;

// Reducer，真正执行修改 state 的纯函数
export default ExportDataSlice.reducer;
